module.exports = __webpack_public_path__ + "img/ico_btn_prod_cart.e18ab8e.svg";